import ClarifyingQuestionsForm from "./ClarifyingQuestionsForm";
import EnhancedQuestions from "./EnhancedQuestions";
import { ClarifyingQuestionsProps, ENHANCED_QUESTIONS_PHASE } from "./types";

export type { ClarifyingAnswer, ClarifyingQuestionsProps } from "./types";

// Dispatches to the right module for the clarification turn. Split into distinct components so
// each keeps a stable hook order regardless of which kind of clarification is rendered.
export default function ClarifyingQuestions(props: ClarifyingQuestionsProps) {
  const { clarification, answered, onSkip, onSkipAndTurnOff, onSelectEnhancedPrompt } = props;

  if (clarification.phase === ENHANCED_QUESTIONS_PHASE) {
    return (
      <EnhancedQuestions
        clarification={clarification}
        answered={answered}
        onSelect={onSelectEnhancedPrompt}
        onSkip={onSkip}
        onSkipAndTurnOff={onSkipAndTurnOff}
      />
    );
  }

  return <ClarifyingQuestionsForm {...props} />;
}
